var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam-page-wrapper"},[_c('ProductContentExam',{attrs:{"contentData":_vm.contentData,"productVariantID":_vm.parsedProductVariantId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }